export default {
    upload: {
        stalled: 'The server stopped reporting on this upload.',
        finalizeFailed: 'Upload failed during finalisation.',
    },
    index: {
        title: 'Media',
        searchPlaceholder: 'Search filename',
        clearSelection: 'Clear',
        selectAll: 'Select all',
        done: 'Done',
        savingOrder: 'Saving order…',
        clearSearchToReorder: 'Clear the search to reorder',
        dragToReorder: 'Drag to reorder',
        select: 'Select',
        dismiss: 'Dismiss',
        empty: 'No media in this folder yet. Upload a file to get started.',
        notConverted: '{name} could not be converted, so the original was kept. It may not play in every browser. Re-export it as a standard MP4 and upload again.',
        usageCheckFailed: 'Could not check where these files are used, so nothing was deleted. {message}',
        deletedFiles: 'Deleted {n} files. | Deleted {n} file. | Deleted {n} files.',
        deleteFailed: '{n} could not be removed: {names}. | {n} could not be removed: {names}.',
        deleteMissing: '{n} was already gone. | {n} were already gone.',
        inUse: 'These files are used on the site. Nothing was deleted yet.',
    },
    edit: {
        libraryRoot: 'Library root',
        confirmDelete: 'Delete "{name}"? Pages still referencing it will show broken images.',
        pathCopied: 'Path copied',
        urlCopied: 'URL copied',
        snippetCopied: 'Snippet copied',
        copyFailed: 'Could not copy to clipboard. Select the text and copy manually.',
        path: 'Path',
        fullUrl: 'Full URL',
        useInTemplate: 'Use in a template',
        notConverted: 'This video could not be converted, so the original file was kept. It may not play in every browser. Re-export it as a standard MP4 and upload again.',
        filename: 'Filename',
        filenameHint: "Renaming rewrites every reference in this website's pages.",
        alt: 'Alt text',
        altHint: 'Describes the image for screen readers.',
        caption: 'Caption',
        folder: 'Folder',
        folderHint: "Where this file shows in the library. Organisation only: the file's URL doesn't change.",
    },
    picker: {
        searchPlaceholder: 'Search…',
        empty: 'No media in this folder. Upload a file to get started.',
        notImage: '{name}: not an image file',
        notVideo: '{name}: not a video file',
        notConverted: 'This video could not be converted and may not play everywhere.',
    },
    folders: {
        library: 'Library',
        newFolder: 'New folder',
        newFolderPrompt: 'New folder name',
        renamePrompt: 'Rename folder',
        rename: 'Rename',
        confirmDelete: 'Delete folder "{name}"? Its files and subfolders move up to the parent.',
    },
    bulkDelete: {
        title: 'Delete {n} files | Delete {n} file | Delete {n} files',
        checking: 'Checking where these files are used…',
        noneInUse: 'None of these files are used on the site. Deleting them cannot be undone.',
        inUse: '{n} of these {total} files is still used on the site. | {n} of these {total} files are still used on the site.',
        warning: 'Deleting them does not remove them from the pages below. Those pages keep pointing at a file that is gone, and will show a blank space where the image was. There is no undo, and nothing on the page will say what happened.',
        usedIn: 'Used in {n} places | Used in {n} place | Used in {n} places',
        otherUnused: 'The other {n} files are not used anywhere. | The other {n} file is not used anywhere. | The other {n} files are not used anywhere.',
        acknowledge: 'I understand that {n} file is still in use and that the pages listed above will break. | I understand that {n} files are still in use and that the pages listed above will break.',
        // Where a file is used; the server owns the list, unknown kinds show raw.
        kinds: {
            page: 'Page',
            pageTranslation: 'Page translation',
            article: 'Article',
            product: 'Product',
            category: 'Category',
            faq: 'FAQ question',
            landingRow: 'Landing page',
            landingTemplate: 'Landing template',
            portfolio: 'Portfolio collection',
        },
    },
};
